export default "__VITE_ASSET__C_TUbO$f__"